<template>
  <div class="content">
    <!--左-->
    <article-side-bar :article-list-nav="articleListNav"></article-side-bar>
    <!--右-->
    <div class="content_right">
      <div class="content_header">
        <span class="title">{{curName.plateName}}</span>
        <span
          class="card"
        >{{articleListNav.menuName}} > {{curName.plateName}} > {{articleDetail.title}}</span>
      </div>
      <div class="article_detail_box">
        <div class="article_title">{{articleDetail.title}}</div>
        <div class="date">{{articleDetail.publishTime}}</div>
        <div class="article_content" v-html="articleDetail.content"></div>
        <p v-if="articleDetail.accessory != null" class="download_file">
          附件:
          <a
            :href="articleDetail.accessory"
            :download="articleDetail.accessoryName"
            target="_blank"
          >{{articleDetail.accessoryName}} &nbsp;&nbsp;&nbsp;&nbsp;点击下载</a>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { queryArticleDetail } from "@/api/ArticleDetail.js";
import { queryArticleList, searchArticleList } from "@/api/ArticleList.js";
import ArticleSideBar from "@/components/ArticleSideBar.vue";
export default {
  components: { ArticleSideBar },
  props: {
    articleListNav: Object
  },
  data() {
    return {
      search: "",
      articleDetail: {}
    };
  },
  computed: {
    curName() {
      let name = this.articleListNav.children.find(item => {
        return item.id == this.$route.query.plateId;
      });
      return name;
    }
  },
  created() {
    this.getArticleDetail();
  },
  methods: {
    getArticleDetail() {
      queryArticleDetail(this.$route.query.articleId).then(res => {
        this.articleDetail = res;
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.article_content {
  a {
    font-size: inherit;
    font-family: inherit;
    color: inherit;
  }
}
</style>
<style lang="scss" scoped>
//$themeColor: #3e76fc;
.content {
  width: 1200px;
  display: flex;
  margin-bottom: 120px;
  .content_right {
    width: 1112px;
    padding-left: 34px;
    .content_header {
      width: 100%;
      height: 86px;
      border-bottom: 1px solid $themeColor;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .title {
        width: 440px;
        font-size: 28px;
        color: $themeColor;
      }
      .card {
        font-size: 14px;
        color: #333;
        width: 500px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        text-align:right;
      }
    }
    .article_detail_box {
      width: 100%;
      .article_title {
        font-size: 22px;
        color: red;
        margin-top: 30px;
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
      }
      .article_content {
        min-height: 300px;
      }
      .download_file {
        margin-top: 30px;
        a {
          font-size: 14px;
          color: blue;
          text-decoration: underline;
        }
      }
      .date {
        font-size: 14px;
        color: #999;
        display: flex;
        justify-content: flex-end;
        margin: 15px 0;
      }
    }
  }
}
</style>
